import {
  Box,
  Button,
  HStack,
  Input,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { useTheme } from "src/hooks/useTheme";

interface DateRangePickerProps {
  startDate: string;
  endDate: string;
  onStartDateChange: (date: string) => void;
  onEndDateChange: (date: string) => void;
}

export const DateRangePicker = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
}: DateRangePickerProps) => {
  const { isOpen, onToggle } = useDisclosure();
  const { header, border, secondaryBackground } = useTheme();

  if (!isOpen) {
    return (
      <Button
        onClick={onToggle}
        variant="ghost"
        size="sm"
        rightIcon={<i className="fa-sharp fa-calendar" />}
        color={header}
      >
        Custom Date Filter
      </Button>
    );
  }

  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "row",
      }}
    >
      <HStack spacing={4}>
        <Box flex={1}>
          <Text color={header} fontSize="sm" marginBottom="0.5rem">
            Start Date
          </Text>
          <Input
            type="date"
            value={startDate}
            onChange={(e) => onStartDateChange(e.target.value)}
            bg={secondaryBackground}
            border={`1px solid ${border} !important`}
            color={header}
            size="sm"
          />
        </Box>
        <Box flex={1}>
          <Text color={header} fontSize="sm" marginBottom="0.5rem">
            End Date
          </Text>
          <Input
            type="date"
            value={endDate}
            onChange={(e) => onEndDateChange(e.target.value)}
            bg={secondaryBackground}
            border={`1px solid ${border} !important`}
            color={header}
            size="sm"
          />
        </Box>
      </HStack>
    </Box>
  );
};
